import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index'),
        meta: { title: '仪表盘', icon: 'el-icon-data-analysis' }
      }
    ]
  }
]

export const asyncRoutes = [
  {
    path: '/marketing',
    component: Layout,
    redirect: '/marketing/activities',
    name: 'MarketingManagement',
    meta: { title: '活动管理', icon: 'el-icon-present', alwaysShow: true },
    children: [
      {
        path: 'activities',
        name: 'ActivityManagement',
        component: () => import('@/views/marketing/activity'),
        meta: { title: '活动管理', icon: 'el-icon-date', permission: 'activity:list' }
      },
      {
        path: 'gifts',
        name: 'GiftManagement',
        component: () => import('@/views/marketing/gift'),
        meta: { title: '礼物管理', icon: 'el-icon-present', permission: 'gift:list' }
      },
      {
        path: 'customers',
        name: 'CustomerManagement',
        component: () => import('@/views/customer/index'),
        meta: { title: '顾客管理', icon: 'el-icon-s-custom', permission: 'customer:list' }
      }
    ]
  },
  {
    path: '/logs',
    component: Layout,
    redirect: '/logs/status',
    name: 'LogManagement',
    meta: { title: '日志管理', icon: 'el-icon-document', alwaysShow: true },
    children: [
      {
        path: 'status',
        name: 'LogUserStatus',
        component: () => import('@/views/log/status'),
        meta: { title: '用户状态', permission: 'log:status' }
      },
      {
        path: 'login',
        name: 'LogLogin',
        component: () => import('@/views/log/login'),
        meta: { title: '登录日志', permission: 'log:login' }
      },
      {
        path: 'operation',
        name: 'LogOperation',
        component: () => import('@/views/log/operation'),
        meta: { title: '操作日志', permission: 'log:operation' }
      },
      {
        path: 'session',
        name: 'LogSession',
        component: () => import('@/views/log/session'),
        meta: { title: '会话日志', permission: 'log:session' }
      }
    ]
  },
  {
    path: '/system-config',
    component: Layout,
    redirect: '/system-config/basic',
    name: 'SystemConfig',
    meta: { title: '系统管理', icon: 'el-icon-setting', alwaysShow: true },
    children: [
      {
        path: '/users',
        name: 'UserManagement',
        component: () => import('@/views/user/index'),
        meta: { title: '后台账号', icon: 'el-icon-user', permission: 'user:list' }
      },
      {
        path: 'basic',
        name: 'SystemBasicConfig',
        component: () => import('@/views/system/basic'),
        meta: { title: '系统设置', permission: 'system:config' }
      },
      {
        path: '/roles',
        name: 'RoleManagement',
        component: () => import('@/views/role/index'),
        meta: { title: '角色管理', icon: 'el-icon-s-custom', permission: 'role:list' }
      },
      {
        path: '/menus',
        name: 'MenuManagement',
        component: () => import('@/views/menu/index'),
        meta: { title: '菜单管理', icon: 'el-icon-menu', permission: 'menu:list' }
      },
      {
        path: 'dictionaries',
        name: 'DictionaryManagement',
        component: () => import('@/views/system/dictionary'),
        meta: { title: '字典管理', icon: 'el-icon-collection-tag', permission: 'dict:list' }
      },
      {
        path: 'permissions',
        name: 'PermissionSettings',
        component: () => import('@/views/permission/settings'),
        meta: { title: '权限管理', icon: 'el-icon-lock', permission: 'permission:list' }
      },
      {
        path: 'tasks',
        name: 'ScheduledTaskManagement',
        component: () => import('@/views/system/task'),
        meta: { title: '任务管理', icon: 'el-icon-time', permission: 'task:list' }
      },
      {
        path: 'password',
        name: 'SystemPassword',
        component: () => import('@/views/system/password'),
        meta: { title: '密码修改' }
      }
    ]
  },
  {
    path: '*',
    redirect: '/dashboard',
    hidden: true
  }
]

const createRouter = () =>
  new Router({
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router
